import React, { useContext } from 'react';
import S from "./Fees.styled";
import CardHeader from "../CardHeader";
import FundContext from '@/components/FundSingle/FundProvider';
import Table from '../../../Table';

const Fees: React.FC<FundSingle> = () => {
    const { fundRiskDetails, outputPercentage } = useContext(FundContext);
    
    if (!fundRiskDetails) return null;
    
    var managementFee = outputPercentage(fundRiskDetails.ActualManagementFee);
    var actualManagementFee = outputPercentage(fundRiskDetails.KID.OngoingCostsOtherCosts);
    var onGoingCharge = '-'; // outputPercentage(fundRiskDetails.PerformanceFee); missing

    var tableData = {
        headings: ['Avgifter', 'Fond'],
        rows: {
            'Förvaltningsavgift': [managementFee],
            'KID avgift Övriga kostnader': [actualManagementFee],
            'Resultatbaserad Avgift %': [onGoingCharge]
        }
    }

    return (
        <S.AllocationWrapper>
            <CardHeader title="Avgifter" />
            <Table tableData={tableData} />
        </S.AllocationWrapper>
    );
};

export default Fees;
